<template>
    <section class="section">
        <div class="container ">
            <div class="columns">
                <div v-for="type in laptopTypes" :key="type.id"
                     class="column is-2">
                    <router-link :to="'/' + type.slug">
                            <div class="card">
                                <div class="card-image">
                                    <figure class="image">
                                        <img :src="type.logo" :alt="type.name">
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <div class="">
                                        <div class="media-left">
                                        </div>
                                        <div class="media-content has-text-centered">
                                            <span class="tag tag__custom is-warning is-medium">{{ type.name}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {API_URL} from "../../main"
    import axios from 'axios'
    import Search from "./Search";

    export default {
        name: "CategoryTiles",
        components: {Search},
        data() {
            return {
                laptopTypes: [],
            }
        },
        methods: {
            fetchLaptopTypes() {
                axios.get(API_URL + '/laptop-types?ordering=order')
                    .then(response => {
                        this.laptopTypes = response.data
                    })
            }
        },
        created() {
            this.fetchLaptopTypes()
        }
    }
</script>

<style scoped>
    .card {
        height: 100%;
    }
    .card:hover {
        -webkit-transform: scale(1.005);
        -ms-transform: scale(1.005);
        transform: scale(1.005);
        transition: 0.3s linear;
        /*background-color: #FFDD57;*/
        border: 0.3px solid orange;
    }
    .tag__custom {
      height: auto !important;
      white-space: unset !important;
      color: black !important;
      width: 100%
    }
</style>
